import Lottie, {LottieProps} from "react-lottie";
import animationData from "../../assets/lotties/error.json"

const Exception = () => {

    const lottieProps: LottieProps = {
        width: 500,
        height: 500,
        options: {
            loop: true,
            autoplay: true,
            animationData: animationData
        }
    }

    return (
        <Lottie {...lottieProps} />
    )
}

export default Exception